<template>
    <servicos
        :permitirAprovar="$temAcessoView('GESCON-GER-SERV-00')"
        :permitirReprovar="$temAcessoView('GESCON-GER-SERV-00')"
        :permiteDetalhar="$temAcessoView('GESCON-GER-SERV-00')"
        rotaDetalhar="Gescon_Gerentes_Servicos_Detalhar"
        rotaListagem="Gescon_Gerentes_Servicos_Listagem"
    ></servicos>
</template>

<script>
import ServicosServicos from './ServicosServicos'
import Servicos from '../../aprovadores/Comprometimentos'

export default {
    name: 'GerentesServicos',
    
    components: {
        Servicos
    },

    data() {
        return {
            servicosServicos: ServicosServicos
        }
    },

    provide() {
        return {
            servicosServicos: this.servicosServicos
        }
    }
}
</script>
